

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail } from "lucide-react";
import UnifiedHeader from "@/components/UnifiedHeader";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <UnifiedHeader />
      
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
            <p className="text-xl text-gray-600">
              Get in touch with our support team. We're here to help!
            </p>
          </div>

          <div className="flex justify-center">
            {/* Contact Information */}
            <div className="w-full max-w-md">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <Mail className="mr-2 h-5 w-5 text-purple-600" />
                    Email Support
                  </CardTitle>
                  <CardDescription>
                    Send us an email and we'll respond within 24 hours
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-lg font-semibold text-purple-600">
                    support@ordereaseonline.com
                  </p>
                  <p className="text-gray-600 mt-4">
                    We typically respond to all inquiries within 24 hours during business days.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

